import { get } from "axios"

const getEstadoEquipamiento = (checks) => {
    let aux = [
        { alta: checks[0] },
        { bio: checks[1] },
        { electro: checks[2] },
        { comple: checks[3] },
        { insta: checks[4] },
        { mobi: checks[5] },
        { infor: checks[6] },
        { estra: checks[7] }
    ]

    // Convertimos en cadena de texto para enviar por
    let queryString = aux.map(obj => {
        let key = Object.keys(obj)[0];
        let value = obj[key] ? 1 : 0; // Convertir true en 1 y false en 0
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }).join('&');

    const token = localStorage.getItem('token');
    return (
        get(`${process.env.REACT_APP_URL_API}dashboard-estado-equipamiento?${queryString}`, {
            headers: {
                'Authorization': `Bearer ${token}`  // Incluye el token JWT en el encabezado
            }
        })
            .then(response => {
                const { data } = response
                return data
            })
            .catch(error => {
                console.log(error)
            })
    )
}
export default getEstadoEquipamiento